import type { ImgHTMLAttributes } from "react";
import { cn } from "../../lib/utils";

type BrandMarkProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "width" | "height">;

export function BrandMark({ alt = "", className, ...props }: BrandMarkProps) {
  return (
    <img
      src="/brand/io-spoke-mark-square-color.png"
      width="220"
      height="220"
      alt={alt}
      className={cn("shrink-0 object-contain", className)}
      {...props}
    />
  );
}
